import * as React from "react";

type PublicPasswordContextType = {
    accessKey: string;
    setAccessKey: React.Dispatch<React.SetStateAction<string>>;
};

const PublicProfileAccessKeyContext = React.createContext<PublicPasswordContextType>({
    accessKey: "",
    setAccessKey: () => {}
});

const PublicProfileAccessKey: React.FunctionComponent<React.PropsWithChildren<{ initialAccessKey?: string }>> = ({
    children,
    initialAccessKey = ""
}) => {
    const [accessKey, setAccessKey] = React.useState(initialAccessKey);
    return <PublicProfileAccessKeyContext.Provider value={{ accessKey, setAccessKey }}>{children}</PublicProfileAccessKeyContext.Provider>;
};

function usePublicProfileAccessKeyContext() {
    const context = React.useContext(PublicProfileAccessKeyContext);
    return context;
}

export { PublicProfileAccessKey, usePublicProfileAccessKeyContext };
